import { CONSTRUCTOR } from '..';

// LeadFieldSettingsResponse fields fragment.
export const leadFieldSettingsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'LeadFieldSettingsResponse',
  fields: `{
    body
    updated_at
  }`,
});

// GetDashboardMetricsResponse fields fragment.
export const getDashboardMetricsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'GetDashboardMetricsResponse',
  fields: `{
    unassigned_leads_count
    pending_first_action_count
    leads_to_follow_up_count
    won_leads_count
    lost_leads_count
  }`,
});

// ActionStatus fields fragment.
export const actionStatusFields = CONSTRUCTOR.FRAGMENT({
  name: 'ActionStatusFields',
  fields: `{
    id
    name
    description
    status
    visibility
    active
    order
    created_at
    updated_at
  }`,
});

// ActionStatusResponse fields fragment.
export const actionStatusResponseFields = CONSTRUCTOR.FRAGMENT({
  name: 'ActionStatusResponseFields',
  fields: `{
    data
    error
  }`,
  fragments: [actionStatusFields],
});
